import { useEffect } from "react";

/**
 * useNoIndex — mounts a `<meta name="robots" content="noindex, nofollow">`
 * tag on any route that shouldn't be crawlable. Reverts on unmount so a
 * user navigating from a demo page back to the marketing site doesn't
 * carry noindex around.
 *
 * Use on demo/prototype routes, admin console, dashboard, auth pages.
 */
export const useNoIndex = () => {
  useEffect(() => {
    const el = document.createElement("meta");
    el.name = "robots";
    el.content = "noindex, nofollow";
    document.head.appendChild(el);
    return () => {
      document.head.removeChild(el);
    };
  }, []);
};
